import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AuthenticationService, MgUser } from '../../core/services/auth.service';
import { LanguageService } from '../../core/services/language.service';
import { StylesChangerService } from '../../core/services/style.service';
import { AccountDropdownComponent } from './account-dropdown/account-dropdown.component';

@Component({
  selector: 'app-topbar',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule, AccountDropdownComponent],
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent implements OnInit {
  @Output() mobileMenuButtonClicked = new EventEmitter<void>();

  user: MgUser | null = null;
  isDarkMode = false;
  currentLang = 'ar';

  constructor(
    private auth: AuthenticationService,
    public languageService: LanguageService,
    private stylesChangerService: StylesChangerService,
    public translate: TranslateService
  ) {
    this.auth.currentUser.subscribe((u) => {
      this.user = u;
    });

    const savedTheme = localStorage.getItem('theme-mode') || 'light';
    this.isDarkMode = savedTheme === 'dark';
    document.body.setAttribute('data-theme', this.isDarkMode ? 'dark' : 'light');

    this.currentLang = localStorage.getItem('lang') || 'ar';
  }

  ngOnInit(): void {
    this.languageService.currentLang.subscribe((lang) => {
      if (lang) {
        this.currentLang = lang;
      }
    });
  }

  toggleMobileMenu(event: Event): void {
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  toggleDarkMode(): void {
    this.isDarkMode = !this.isDarkMode;
    const theme = this.isDarkMode ? 'dark' : 'light';
    document.body.setAttribute('data-theme', theme);
    this.stylesChangerService.setThemeMode(theme);
  }

  toggleLanguage(): void {
    const newLang = this.currentLang === 'ar' ? 'en' : 'ar';
    this.languageService.setLanguage(newLang);
    this.currentLang = newLang;
  }
}
